export function hasJwtToken(token: string | null | undefined): boolean {
  if (!token || token === "null" || token === "undefined") return false;
  try {
    const parts = token.split(".");
    if (parts.length < 2) return false;
    JSON.parse(atob(parts[1]));
    return true;
  } catch {
    return false;
  }
}

export function isValidJwtToken(token: string | null | undefined): boolean {
  if (!hasJwtToken(token)) return false;
  try {
    const payload = JSON.parse(atob(token!.split(".")[1]));
    return typeof payload.exp === "number" && payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

export function isAccountAuthRoute(path: string): boolean {
  return /\/account\/login(\/|$)/i.test(path);
}

export function shouldSkipAuthRetry(url: string): boolean {
  return /\/account\/(captcha|login|refresh-token|login-With-2FA|register|forgot-password|check-fogot-password-otp)/i.test(
    url,
  );
}
